import React, { Component } from 'react';
import PropTypes from "prop-types";
import LoadingStates from "../../constants/states/LoadingStates";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";


export default class PrivateSERPGoogleMapView extends Component {

    static propTypes = {
        longitude: PropTypes.number.isRequired,
        latitude: PropTypes.number.isRequired,
        results: PropTypes.array.isRequired,
        loadingState: PropTypes.symbol.isRequired,
        zoomLevel: PropTypes.number.isRequired,
        minPrice: PropTypes.number.isRequired,
        maxPrice: PropTypes.number.isRequired,
        orderBy: PropTypes.symbol.isRequired,
        placeId: PropTypes.string.isRequired,
        distance: PropTypes.number.isRequired,
        mapCurrentCenter: PropTypes.shape({
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired
        }).isRequired,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loadingState === LoadingStates.FINISHED_LOADING &&
            (prevProps.longitude !== this.props.longitude ||
                prevProps.latitude !== this.props.latitude ||
                prevProps.results !== this.props.results)) {
            this._renderMap()
        }
    }

    componentDidMount() {
        this._renderMap()
    }

    render() {
        return (
            <div id="map" className="serp-map"/>
        );
    }

    _renderMap() {
        const google = window.google;
        const center = {lat: this.props.latitude, lng: this.props.longitude}

        const map =
            new google.maps.Map(
                document.getElementById("map"),
                {
                    zoom: this.props.zoomLevel,
                    center: center,
                    streetViewControl: false,
                    mapTypeControl: false,
                    disableDoubleClickZoom: true,
                    fullscreenControl: false,
                    clickableIcons: false,
                    maxZoom: 19,
                });
        this.props.results.forEach(
            result => {
                const marker =
                    new google.maps.Marker(
                        {
                            position: {lat: result.latitude, lng: result.longitude},
                            map: map,
                            icon: "./CuveredPinSmall.png"
                        });
                google.maps.event.addListener(
                    marker,
                    'click',
                    function() {
                        map.setCenter(marker.getPosition());
                        EventPublisher.publish(UIInteractionEvents.SPACE_MARKER_CLICK, {spaceId: result.spaceId});
                    });
            });
        google.maps.event.addListener(
            map,
            'zoom_changed',
            () => this.onZoomChange(
                map.getBounds().getCenter(),
                map.getBounds().getNorthEast(),
                map.getZoom(),
                map,
                google));

        google.maps.event.addListener(
            map,
            'center_changed',
            () => {
                this.onCenterChange(map, google);
            });

    }

    onZoomChange = (center, northEast, zoomLevel, map, google) => {
        const R = 3958.8; // Radius of the Earth in miles
        const rlat1 = center.lat() * (Math.PI/180); // Convert degrees to radians
        const rlat2 = northEast.lat() * (Math.PI/180); // Convert degrees to radians
        const difflat = rlat2-rlat1; // Radian difference (latitudes)
        const difflon = (northEast.lng()-center.lng()) * (Math.PI/180); // Radian difference (longitudes)
        const d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
        EventPublisher.publish(
            UIInteractionEvents.MAP_ZOOM_CHANGED,
            {
                zoomLevel: zoomLevel,
                distance: d.toFixed(2)});
        this.onCenterChange(map, google);
    };

    onCenterChange = (map, google) => {
        if(document.getElementById("searchCenterChange") === null) {
            const centerControlDiv = document.createElement("div");
            centerControlDiv.setAttribute("id", "searchCenterChange");
            this.searchOnChangeCenterControl(centerControlDiv);
            map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);
        }
        EventPublisher.publish(
            UIInteractionEvents.MAP_CENTER_CHANGED,
            {"latitude":map.getCenter().lat(), "longitude": map.getCenter().lng()})
    };

    searchOnChangeCenterControl = (controlDiv) => {
        // Set CSS for the control border.
        const controlUI = document.createElement("div");
        controlUI.style.backgroundColor = "#fff";
        controlUI.style.border = "2px solid #fff";
        controlUI.style.borderRadius = "3px";
        controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
        controlUI.style.cursor = "pointer";
        controlUI.style.marginBottom = "22px";
        controlUI.style.textAlign = "center";
        controlUI.title = "Click to search new area on map";
        controlDiv.appendChild(controlUI);
        // Set CSS for the control interior.
        const controlText = document.createElement("div");
        controlText.style.color = "rgb(25,25,25)";
        controlText.style.fontFamily = "Roboto,Arial,sans-serif";
        controlText.style.fontSize = "16px";
        controlText.style.lineHeight = "38px";
        controlText.style.paddingLeft = "5px";
        controlText.style.paddingRight = "5px";
        controlText.innerHTML = "Search new area";
        controlUI.appendChild(controlText);
        // Setup the click event listeners: simply set the map to Chicago.
        controlUI.addEventListener("click", () => {
            EventPublisher.publish(UIInteractionEvents.MAP_SEARCH_NEW_AREA_BUTTON_CLICKED, {
                "spaceId": this.props.spaceId,
                "maxPrice": this.props.maxPrice,
                "minPrice": this.props.minPrice,
                "orderBy": this.props.orderBy,
                "distance": this.props.distance,
                "latitude": this.props.mapCurrentCenter.latitude,
                "longitude": this.props.mapCurrentCenter.longitude});
            EventPublisher.publish(UIInteractionEvents.PAGINATION_CHANGE, 1);
        });
    }
}

